"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;
exports.CONNECT_STILL_PENDING = exports.CONNECT_REJECTED = exports.CONNECT_PENDING = exports.CONNECT_FULFILLING = exports.CONNECT_FULFILLED = exports.CONNECT = void 0;
var CONNECT = 'DIRECT_LINE/CONNECT';
exports.CONNECT = CONNECT;
var CONNECT_FULFILLED = "".concat(CONNECT, "_FULFILLED");
exports.CONNECT_FULFILLED = CONNECT_FULFILLED;
var CONNECT_FULFILLING = "".concat(CONNECT, "_FULFILLING");
exports.CONNECT_FULFILLING = CONNECT_FULFILLING;
var CONNECT_PENDING = "".concat(CONNECT, "_PENDING");
exports.CONNECT_PENDING = CONNECT_PENDING;
var CONNECT_REJECTED = "".concat(CONNECT, "_REJECTED");
exports.CONNECT_REJECTED = CONNECT_REJECTED;
var CONNECT_STILL_PENDING = "".concat(CONNECT, "_STILL_PENDING");
exports.CONNECT_STILL_PENDING = CONNECT_STILL_PENDING;

function _default(_ref) {
  var directLine = _ref.directLine,
      userID = _ref.userID,
      username = _ref.username;
  return {
    type: CONNECT,
    payload: {
      directLine: directLine,
      userID: userID,
      username: username
    }
  };
}